import request from '@/utils/request'

export function company () {
  return request({
    url: 'api/company',
    method: 'get'
  })
}

export function addCompany (data) {
  return request({
    url: 'api/company',
    method: 'post',
    data
  })
}

export function editCompany (data) {
  return request({
    url: 'api/company',
    method: 'put',
    data
  })
}

export function deleteCompany (uuid) {
  return request({
    url: 'api/company/' + uuid,
    method: 'delete'
  })
}

export function contact () {
  return request({
    url: 'api/contact',
    method: 'get'
  })
}

export function addContact (data) {
  return request({
    url: 'api/contact',
    method: 'post',
    data
  })
}

export function editContact (data) {
  return request({
    url: 'api/contact',
    method: 'put',
    data
  })
}

export function deleteContact (uuid) {
  return request({
    url: 'api/contact/' + uuid,
    method: 'delete'
  })
}
